module.exports = __webpack_public_path__ + "img/nodejs-resized.9c8c67ab.png";